import { GetWearableObservationsMhdBatch } from "@/services/fhir/observation/GetWearableObservationsMhdBatch";

/**
 * Busca Observations do período via **POST Bundle** no EHRRunner (MHD),
 * no formato PatientSummary (`subject=Patient/{oids.cpf-CPF}&status=final&...`).
 */
export async function fetchWearableObservationEntries(params: {
  patientId: string;
  periodStartKey: string;
  periodEndKey: string;
  rangeDays: number;
}): Promise<any[]> {
  return GetWearableObservationsMhdBatch(params);
}
